import React, { Component, Suspense, lazy } from "react";
import { Route, Routes, useParams } from "react-router-dom";

import Spinner from "../app/shared/Spinner";
import Dashboard from "./dashboard/Dashboard";
import Error404 from "./error-pages/Error404";
import Error500 from "./error-pages/Error500";
import Buttons from "./basic-ui/Buttons";
import Typography from "./basic-ui/Typography";
import Dropdowns from "./basic-ui/Dropdowns";
import BlankPage from "./general-pages/BlankPage";
import Lockscreen from "./user-pages/Lockscreen";
import Register1 from "./user-pages/Register";
import Login from "./user-pages/Login";
import ChartJs from "./charts/ChartJs";
import BasicTable from "./tables/BasicTable";
import BasicElements from "./form-elements/BasicElements";
import Mdi from "./icons/Mdi";
import Sidebar1 from "./shared/Sidebar1_Before_Reddychanges";
import LoggedInUser from "./user-pages/LoggedInUser";
// import UserProfile from './user-pages/UserProfile';
import UserProfile from "./user-pages/UserProfile";
// import Users from './user-pages/Users';
import Users from "./user-pages/Users_new";
import Riders from "./Riders/Riders";
import RidersProfile from "./Riders/RidersProfile";
import TripDetails from "./dashboard/TripDetails";
import TripDetail from "./TripDetails/TripDetails";
import Riders_new from "./Riders/Riders_new";
import OnGoingTrip from "./TripDetails/OnGoingTrip";
import Trips from "./TripDetails/Trips";
import TestingBilling from "./dashboard/TestingBilling";
import ExcludesZone from "./excludesZones/ExcludesZone";
import CityConfig from "./cityConfig/CityConfig";
import City from "./city/City";
import CityDetails from "./city/CityDetails";
import AutoBidMatrix from "./AutoBidMatrix/AutoBidMatrix";
import DashboardServices from "./dashboard/Services/DashboardServices";
import ServiceEditor from "./dashboard/Services/ServiceEditor";
import DriverEarnings from "./Riders/earnings/DriverEarnings";
import TripChart from "./charts/TripChart";
import TripTrafficChart from "./charts/TripTrafficChart";
import Notification from "./notification/Notification";
import Movies from "./Tickets/Movies/Movies";

import MovieDetails from "./Tickets/Movies/MovieDetails";
import BookedSeats from "./Tickets/Bookings/BookedSeats";
import AddMovies from "./Tickets/Movies/AddMovies";
import UpdateShowtimes from "./Tickets/ShowTimes/showTime";
import CruzeAdminList from "./admin/CruzeAdminList";
import CruzeAdminPage from "./admin/CruzeAdminPage";
import NearbyIndexList from "./Locale/NearbyLoc";
import CruzeTypes from "./CruzeTypes/cruzeTypes";
import Places from "./TourPackages/Places/Places";
import PlaceDetail from "./TourPackages/Places/PlaceDetails";
import Packages from "./TourPackages/Packages/packages";
import EditPackage from "./TourPackages/Packages/editPackages";
import Payment from "./Payment/payment";
import UploadBankStatement from "./Payment/UploadBankStatement";
import Images from "./adds/Images";
import Offers from "./offers/Offers";
import ScanneDataDetails from "./scans/ScannedDataDetails";
import ScannedDataDetails from "./scans/ScannedDataDetails";
import Coupons from "./TourPackages/Coupon/Coupons";
import CabRequestList from "./cabRequests/CabRequestList";
import CabRequestDetails from "./cabRequests/CabRequestDetails";
import TicketDashboard from "./ticketDashboard/TicketDashboard";
import TicketDashboardV2 from "./ticketDashboard/TicketDashboardV2";
import AddValidity from "./Tickets/Movies/AddValidity";
import EditMovie from "./Tickets/Movies/EditMovie";
import ShowSchedules from "./Tickets/ShowTimes/ShowSchedules";
import EditValidity from "./Tickets/ShowTimes/EditValidity";
import ConfirmTicket from "./Tickets/Confirm/ConfirmTicket";
import PricingConfig from "./PaymentConfig/PricingConfig";
import Profiles from "./PaymentConfig/GatewaysV2/Profiles";
import Accounts from "./PaymentConfig/GatewaysV2/Accounts";
import ServicePaymentPolicy from "./PaymentConfig/GatewaysV2/ServicePaymentPolicy";
import RefundsV2 from "./PaymentConfig/GatewaysV2/RefundsV2";
import TheatersMaster from "./Masters/TheatersMaster";

import PaymentTicket from "./Tickets/Confirm/PaymentTicket";
import PaymentStatus from "./Tickets/Confirm/PaymentStatus";
import PaymentTicketV2 from "./Tickets/Confirm/PaymentTicketV2";
import PaymentStatusV2 from "./Tickets/Confirm/PaymentStatusV2";
import ProtectedRoute from "./ProtectedRoute";
import NotAuthorized from "./NotAuthorized";
import RoleRedirect from "./RoleRedirect";

import Reports from "./Tickets/Reports/Reports";
import DynamicPricing from "./Tickets/DynamicPricing/DynamicPricing";
import DynamicReport from "./Tickets/DynamicPricing/DynamicReport";
import PurchaseCost from "./Tickets/DynamicPricing/PurchaseCost";
import Approvals from "./Tickets/DynamicPricing/Approvals";
import ApproveList from "./Tickets/DynamicPricing/ApproveList";
import { BookingProvider } from "../context/BookingContext";
import MovieBooking from "./Tickets/Movies/MovieBooking";
import ShowPerformance from "./Tickets/Reports/ShowPerformance";
import RevenueReport from "./Tickets/Reports/RevenueReport";
import PaymentOrReportSelector from "./Tickets/Reports/PaymentOrReportSelecto";
import ConsolidatedReport from "./Tickets/Reports/ConsolidatedReport";
import RedirectToTicket from "./Tickets/Confirm/RedirectToTicket";
import Spots from "./TourPackages/Spots/Spots";
import EditSpot from "./TourPackages/Spots/EditSpot";
import AddSpot from "./TourPackages/Spots/AddSpot";

// For the seperate files

import FileUploadPage from "./Payment/FileUploadPage";
import SettlementReportPage from "./Payment/SettlementReportPage";
import { FileUpload } from "@mui/icons-material";
import GSTSplit from "./Tickets/Reports/GSTSplit";
import ZoneMap from "./zones/zones";
import MasterSeatEditor from "./Tickets/DynamicPricing/MasterSeatEditor";
import FullReport from "./Tickets/Reports/Insights";
import SingleReport from "./Tickets/Reports/SingleReport";
import ReportsV2 from "./Tickets/reportv2/Reports";
import RevenueReportV2 from "./Tickets/reportv2/RevenueReport";
import ConsolidatedReportV2 from "./Tickets/reportv2/ConsolidatedReport";
import GSTSplitV2 from "./Tickets/reportv2/GSTSplit";
import FullReportV2 from "./Tickets/reportv2/Insights";
import SingleReportV2 from "./Tickets/reportv2/SingleReport";
import ShowPerformanceV2 from "./Tickets/reportv2/ShowPerformance";
import PaymentOrReportSelectorV2 from "./Tickets/reportv2/PaymentOrReportSelecto";
import AddVehicleRoute from "./Tracking/vehicle-route/AddVehicleRoute";
import EditVehicleRoute from "./Tracking/vehicle-route/EditVehicleRoute";
import VehicleRoutes from "./Tracking/vehicle-route/VehicleRoutes";

// import VehicleDashboard from "./Tracking/VehicleDashboard";
import UserApprovalScreen from "./Tracking/UserApprovals/userApprovalList";
import VehicleManagement from "./Tracking/Dashboard";
import ApprovedUsersPage from "./Tracking/UserApprovals/ApprovedUsersPage";
import VehicleDetails from "./Tracking/Vehicle/vehicleDetails";
import VehiclesList from "./Tracking/Vehicle/vehicleList";
import BusLocation from "./Tracking/Location/BusLocation";
import Owners from "./Tracking/Owners/Owners";

// import SidebarWithLocation from './shared/Sidebar1';

// const Dashboard = lazy(() => import('./dashboard/Dashboard'));

// const Buttons = lazy(() => import('./basic-ui/Buttons'));
// const Dropdowns = lazy(() => import('./basic-ui/Dropdowns'));
// const Typography = lazy(() => import('./basic-ui/Typography'));

// const BasicElements = lazy(() => import('./form-elements/BasicElements'));

// const BasicTable = lazy(() => import('./tables/BasicTable'));

// const Mdi = lazy(() => import('./icons/Mdi'));

// const ChartJs = lazy(() => import('./charts/ChartJs'));

// const Error404 = lazy(() => import('./error-pages/Error404'));
// const Error500 = lazy(() => import('./error-pages/Error500'));

// const Login = lazy(() => import('./user-pages/Login'));
// const Register1 = lazy(() => import('./user-pages/Register'));
// const Lockscreen = lazy(() => import('./user-pages/Lockscreen'));

// const BlankPage = lazy(() => import('./general-pages/BlankPage'));

function AppRoutes() {
  let user = localStorage.getItem("token");
  let admin = JSON.parse(localStorage.getItem("admin"));
  console.log("adminData", admin.role);
  console.log("user role in the App Routes", user.role);
  const appid = useParams();
  return (
    <Suspense fallback={<Spinner />}>
      <BookingProvider>
        {" "}
        {/* Move BookingProvider outside of Routes */}
        <Routes>
          <Route path="/not-authorized" element={<NotAuthorized />} />

          <Route path="/" element={<RoleRedirect />} />

          {/* <Route path='/' element={<SidebarWithLocation/>}></Route> */}
          {/* <Route path="/" element={ <Sidebar1 />} /> */}

          {/* Original started here  */}

          {/* <Route path={user ? "/dashboard" : "/"} element={<Dashboard />} /> */}
          {/* <Route
          exact
          path={user ? "/basic-ui/buttons" : "/"}
          element={<Buttons />}
        />
        <Route
          exact
          path={user ? "/basic-ui/dropdowns" : "/"}
          element={<Dropdowns />}
        />
        <Route
          exact
          path={user ? "/basic-ui/typography" : "/"}
          element={<Typography />}
        />

        <Route
          path={user ? "/form-Elements/basic-elements" : "/"}
          element={<BasicElements />}
        />

        <Route
          path={user ? "/tables/basic-table" : "/"}
          element={<BasicTable />}
        />

        <Route path={user ? "/icons/mdi" : "/"} element={<Mdi />} /> */}

          {/* <Route path={user?"/charts/chart-js":'/'} element={ <ChartJs/> } /> */}

          {/* <Route path={user ? "/dashboard" : "/"} element={<Login />} />
        <Route
          path={user ? "/user-pages/register-1" : "/"}
          element={<Register1 />}
        />
        <Route
          path={user ? "/user-pages/lockscreen" : "/"}
          element={<Lockscreen />}
        />

        <Route
          path={user ? "/error-pages/error-404" : "/"}
          element={<Error404 />}
        />
        <Route
          path={user ? "/error-pages/error-500" : "/"}
          element={<Error500 />}
        />

        <Route
          path={user ? "/general-pages/blank-page" : "/"}
          element={<BlankPage />}
        />
        <Route path={user ? "/" : null} element={<LoggedInUser />} />
        <Route path="/users/:id" element={<UserProfile />} />
        <Route path={user ? "/users" : "/"} element={<Users />} />
        <Route path={user ? "/riders" : "/"} element={<Riders_new />}></Route>

        <Route
          path={user ? "/riders/:id" : "/"}
          element={<RidersProfile />}
        ></Route>
        <Route
          path={user ? "/trip/:id" : "/"}
          element={<TripDetails />}
        ></Route>
        <Route
          path={user ? "/trip/onGoingTrip" : "/"}
          element={<OnGoingTrip />}
        ></Route>
        <Route path={user ? "/trips" : "/"} element={<Trips />}></Route>
        <Route
          path={user ? "/Exclude-zone" : "/"}
          element={<ExcludesZone />}
        ></Route>
        <Route
          path={user ? "/cityconfig" : "/"}
          element={<CityConfig />}
        ></Route>
        <Route path={user ? "/city" : "/"} element={<City />}></Route>
        <Route
          path={user ? "/city/details" : "/"}
          element={<CityDetails />}
        ></Route>
        <Route
          path={user ? "/dashboard/services" : "/"}
          element={<DashboardServices />}
        ></Route>
        <Route
          path={user ? "/dashboard/services/:id" : "/"}
          element={<ServiceEditor />}
        ></Route> */}

          {/* <Route path={user?'/example':'/'} element={<Example/>}></Route> */}
          {/* <Route path="/trip-details/completed" element={<TripDetail />} />
<Route path="/trip-details/cancelled" element={<TripDetail/>} /> */}
          {/* <Redirect to="/dashboard" /> */}
          {/* <Route
          path={user ? "/notification" : "/"}
          element={<Notification />}
        ></Route>

        <Route
          path={admin.role === "superAdmin" ? "/adminList" : "/"}
          element={<AdminList />}
        ></Route>
        <Route
          path={user ? "/nearyByLocation" : "/"}
          element={<NearbyIndexList />}
        ></Route>
        <Route
          path={user ? "/cruzeTypes" : "/"}
          element={<CruzeTypes />}
        ></Route> */}

          {/* tour Package */}
          {/* <Route
          path={user ? "/tourPackagePlaces" : "/"}
          element={<Places />}
        ></Route>
        <Route
          path={user ? "/tourPackagePlaces/:id" : "/"}
          element={<PlaceDetail />}
        ></Route>
        <Route path={user ? "/packages" : "/"} element={<Packages />}></Route>

        <Route
          path={user ? "/editPackage/:id" : "/"}
          element={<EditPackage />}
        ></Route>
        <Route

          path={user ? "/editPackage" : "/"} // For creating a new package
          element={<EditPackage />}
        /> */}
          {/* payment\  \ */}
          {/* <Route
          path={user ? "/payment" : "/"} // For creating a new package
          element={<Payment />}
        />
        <Route
          path={user ? "/advertise" : "/"} // For creating a new package
          element={<Images />}
        />
        <Route
          path={user ? "/offers" : "/"}  // For creating a new package
          element={<Offers />}
        />
        <Route path={user ? "/scannedDetails" : "/"} element={<ScannedDataDetails />} />

        <Route path={user ? "/coupons" : "/"} element={<Coupons />} />
        <Route path={user ? "/cabRequests" : "/"} element={<CabRequestList />} />
        <Route path={user ? "/cabrequestdetails/:id" : "/"} element={<CabRequestDetails />} /> */}

          {/* Original end here  */}

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute admin={admin} disallowedRoles={["ticket-admin", "earnings-report-only"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/basic-ui/buttons"
            element={
              <ProtectedRoute admin={admin}>
                <Buttons />
              </ProtectedRoute>
            }
          />
          <Route
            path="/basic-ui/dropdowns"
            element={
              <ProtectedRoute admin={admin}>
                <Dropdowns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/basic-ui/typography"
            element={
              <ProtectedRoute admin={admin}>
                <Typography />
              </ProtectedRoute>
            }
          />
          <Route
            path="/form-Elements/basic-elements"
            element={
              <ProtectedRoute admin={admin}>
                <BasicElements />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tables/basic-table"
            element={
              <ProtectedRoute admin={admin}>
                <BasicTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/icons/mdi"
            element={
              <ProtectedRoute admin={admin}>
                <Mdi />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute admin={admin} disallowedRoles={["ticket-admin", "earnings-report-only"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-pages/register-1"
            element={
              <ProtectedRoute admin={admin}>
                <Register1 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-pages/lockscreen"
            element={
              <ProtectedRoute admin={admin}>
                <Lockscreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/error-pages/error-404"
            element={
              <ProtectedRoute admin={admin}>
                <Error404 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/error-pages/error-500"
            element={
              <ProtectedRoute admin={admin}>
                <Error500 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/general-pages/blank-page"
            element={
              <ProtectedRoute admin={admin}>
                <BlankPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute admin={admin}>
                <LoggedInUser />
              </ProtectedRoute>
            }
          />
          <Route path="/users/:id" element={<UserProfile />} />
          <Route
            path="/users"
            element={
              <ProtectedRoute admin={admin}>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/riders"
            element={
              <ProtectedRoute admin={admin}>
                <Riders_new />
              </ProtectedRoute>
            }
          />
          <Route
            path="/riders/:id"
            element={
              <ProtectedRoute admin={admin}>
                <RidersProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trip/:id"
            element={
              <ProtectedRoute admin={admin}>
                <TripDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trip/onGoingTrip"
            element={
              <ProtectedRoute admin={admin}>
                <OnGoingTrip />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trips"
            element={
              <ProtectedRoute admin={admin}>
                <Trips />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Exclude-zone"
            element={
              <ProtectedRoute admin={admin}>
                <ExcludesZone />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cityconfig"
            element={
              <ProtectedRoute admin={admin}>
                <CityConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path="/city"
            element={
              <ProtectedRoute admin={admin}>
                <City />
              </ProtectedRoute>
            }
          />
          <Route
            path="/city/details"
            element={
              <ProtectedRoute admin={admin}>
                <CityDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/services"
            element={
              <ProtectedRoute admin={admin}>
                <DashboardServices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/services/:id"
            element={
              <ProtectedRoute admin={admin}>
                <ServiceEditor />
              </ProtectedRoute>
            }
          />

          <Route
            path="/notification"
            element={
              <ProtectedRoute admin={admin}>
                <Notification />
              </ProtectedRoute>
            }
          />

          <Route
            path="/cruze-admins"
            element={
              <ProtectedRoute admin={admin} allowedRoles={["superAdmin"]}>
                <CruzeAdminPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/nearyByLocation"
            element={
              <ProtectedRoute admin={admin}>
                <NearbyIndexList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/cruzeTypes"
            element={
              <ProtectedRoute admin={admin}>
                <CruzeTypes />
              </ProtectedRoute>
            }
          />

          {/* Tour Package */}
          <Route
            path="/tourPackagePlaces"
            element={
              <ProtectedRoute admin={admin}>
                <Places />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tourPackagePlaces/:id"
            element={
              <ProtectedRoute admin={admin}>
                <PlaceDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/packages"
            element={
              <ProtectedRoute admin={admin}>
                <Packages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editPackage/:id"
            element={
              <ProtectedRoute admin={admin}>
                <EditPackage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editPackage"
            element={
              <ProtectedRoute admin={admin}>
                <EditPackage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/spots"
            element={
              <ProtectedRoute admin={admin}>
                <Spots />
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-spot/:id"
            element={
              <ProtectedRoute admin={admin}>
                <EditSpot />
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-spot"
            element={
              <ProtectedRoute admin={admin}>
                <AddSpot />
              </ProtectedRoute>
            }
          />

          {/* Tour Package */}
          <Route
            path="/tourPackagePlaces"
            element={
              <ProtectedRoute admin={admin}>
                <Places />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tourPackagePlaces/:id"
            element={
              <ProtectedRoute admin={admin}>
                <PlaceDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/packages"
            element={
              <ProtectedRoute admin={admin}>
                <Packages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editPackage/:id"
            element={
              <ProtectedRoute admin={admin}>
                <EditPackage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/editPackage"
            element={
              <ProtectedRoute admin={admin}>
                <EditPackage />
              </ProtectedRoute>
            }
          />

          {/* Payment */}
          <Route
            // path="/payment"
            path="/fileUpload"
            element={
              <ProtectedRoute admin={admin}>
                {/* <Payment /> */}
                <FileUploadPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/settlementReport"
            element={
              <ProtectedRoute
                admin={admin}
                allowedRoles={["superAdmin", "earnings-report-only"]}
                disallowedRoles={[]}
              >
                {/* <Payment /> */}
                <SettlementReportPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/advertise"
            element={
              <ProtectedRoute admin={admin}>
                <Images />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offers"
            element={
              <ProtectedRoute admin={admin}>
                <Offers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scannedDetails"
            element={
              <ProtectedRoute admin={admin}>
                <ScannedDataDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/coupons"
            element={
              <ProtectedRoute admin={admin}>
                <Coupons />
              </ProtectedRoute>
            }
          />

          <Route
            path="/cabRequests"
            element={
              <ProtectedRoute admin={admin}>
                <CabRequestList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/autoBidMatrix"
            element={
              <ProtectedRoute admin={admin}>
                <AutoBidMatrix />
              </ProtectedRoute>
            }
          />
          <Route
            path="/zones"
            element={
              <ProtectedRoute admin={admin}>
                <ZoneMap />
              </ProtectedRoute>
            }
          />
          {/* <Route 
          path ='/vehicle-dashboard'
          element={
<ProtectedRoute admin={admin}>
<VehicleDashboard/>
</ProtectedRoute>
          }/> */}
          <Route
            path="/cabrequestdetails/:id"
            element={
              <ProtectedRoute admin={admin}>
                <CabRequestDetails />
              </ProtectedRoute>
            }
          />

          <Route
            path="/tracking-owners"
            element={
              <ProtectedRoute admin={admin}>
                <Owners />
              </ProtectedRoute>
            }
          />

          <Route
            path="/add-vehicle-route"
            element={
              <ProtectedRoute admin={admin}>
                <AddVehicleRoute />
              </ProtectedRoute>
            }
          />

          <Route
            path="/edit-vehicle-route/:id"
            element={
              <ProtectedRoute admin={admin}>
                <EditVehicleRoute />
              </ProtectedRoute>
            }
          />
          {/* <Route path ='/vehicle-routes'
          element={
<ProtectedRoute admin={admin}>
<VehicleRoutes/>
</ProtectedRoute>
          }/> */}
          <Route
            path="/user-approvals"
            element={
              <ProtectedRoute admin={admin}>
                <UserApprovalScreen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/vehicle-routes"
            element={
              <ProtectedRoute admin={admin}>
                <VehicleRoutes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tracking-dashboard"
            element={
              <ProtectedRoute admin={admin}>
                <VehicleManagement />
              </ProtectedRoute>
            }
          />
          <Route path="/vehicles/:id"  element={
              <ProtectedRoute admin={admin}>
                <VehicleDetails />
              </ProtectedRoute>
            } />
            <Route path="/vehicles/new"  element={
              <ProtectedRoute admin={admin}>
                <VehicleDetails />
              </ProtectedRoute>
            } />
         
          <Route path="/vehiclesList"  element={
              <ProtectedRoute admin={admin}>
                <VehiclesList />
              </ProtectedRoute>
            } />

             
          <Route path="/busLocation/:busId"  element={
              <ProtectedRoute admin={admin}>
                <BusLocation />
              </ProtectedRoute>
            } />

          <Route
            path="/tracking-approved-users"
            element={<ApprovedUsersPage />}
          />

          {/* For the tickets routes seperated as ticket admin should not see the other api's */}

          {/* <Route path={user ? "/tickets-dashboard" : "/"} element={<TicketDashboard />} />


        <Route path={user ? "/movies" : "/"} element={<Movies />}></Route>
        <Route
          path={user ? "/movieDetails/:movieId" : "/"}
          element={<MovieDetails />}
        ></Route>
        <Route
          path={user ? "/bookedSeats" : "/"}
          element={<BookedSeats />}
        ></Route>
        <Route path={user ? "/addMovies" : "/"} element={<AddMovies />}></Route>
        <Route
          path={user ? "updateShowtimes/:id" : "/"}
          element={<UpdateShowtimes />}
        ></Route>

        <Route path={user ? "/reports" : "/"} element={<Reports />}></Route>

        <Route path={user ? "/addValidity" : "/"} element={<AddValidity />}></Route>

        <Route path={user ? "/editMovies" : "/"} element={<EditMovie />}></Route>
        <Route path={user ? "/showSchedules" : "/"} element={<ShowSchedules />}></Route>
        <Route path={user ? "/editValidity" : "/"} element={<EditValidity />}></Route>
        <Route path="/confirm-ticket" element={<ConfirmTicket />} />
        <Route path={user ? "/paymentTicket" : "/not found"} element={<PaymentTicket />}></Route>
       <Route path={user ? "/paymentStatus" : "/not found"} element={<PaymentStatus />}></Route> */}
          {/* <Route path="/paymentTicket/PaymentStatus/:id" element={<PaymentStatus />} />   */}

          {/* This has to be done for the role */}

          {user && (
            <>
              {/* // <BookingContext.Provider value={{ needsRefresh, setNeedsRefresh }}> */}

              {/* <BookingProvider> */}
              {/* <Routes> */}
              <Route path="/tickets-dashboard" element={<TicketDashboard />} />
              <Route path="/ticket-dashboardV2" element={<TicketDashboardV2 />} />
              <Route path="/movies" element={<Movies />} />
              <Route path="/movieDetails/:movieId" element={<MovieDetails />} />
              <Route path="/bookedSeats" element={<BookedSeats />} />
              <Route path="/addMovies" element={<AddMovies />} />
              <Route
                path="/updateShowtimes/:id"
                element={<UpdateShowtimes />}
              />
              <Route path="/reports" element={<Reports />} />
              <Route path="/addValidity" element={<AddValidity />} />
              <Route path="/editMovies" element={<EditMovie />} />
              <Route path="/showSchedules" element={<ShowSchedules />} />
              <Route path="/editValidity" element={<EditValidity />} />
              <Route path="/confirm-ticket" element={<ConfirmTicket />} />
              <Route path="/pricingConfig" element={<PricingConfig />} />
              {/* Payments v2 config */}
              <Route path="/paymentsV2/profiles" element={<Profiles />} />
              <Route path="/paymentsV2/accounts" element={<Accounts />} />
              <Route path="/paymentsV2/policies" element={<ServicePaymentPolicy />} />
              <Route path="/paymentsV2/refunds" element={<RefundsV2 />} />
              <Route path="/theaters-master" element={<TheatersMaster />} />
              <Route path="/paymentTicket" element={<PaymentTicket />} />
              <Route
                path="/paymentTicket/PaymentStatus/:id"
                element={<PaymentStatus />}
              />
              {/* Payments v2 routes (parallel) */}
              <Route path="/paymentTicketV2" element={<PaymentTicketV2 />} />
              <Route path="/paymentsV2/status/:id" element={<PaymentStatusV2 />} />
              <Route path="/dynamicPricing" element={<DynamicPricing />} />
              <Route path="/dynamicReport" element={<DynamicReport />} />
              <Route path="/purchaseCost" element={<PurchaseCost />} />
              <Route path="/approvals" element={<Approvals />} />
              <Route path="/approveList" element={<ApproveList />} />
              <Route path="/moviebooking" element={<MovieBooking />} />
              <Route path="/showPerformance" element={<ShowPerformance />} />
              <Route path="/revenueReports" element={<RevenueReport />} />
              <Route
                path="/paymentSelector"
                element={<PaymentOrReportSelector />}
              />
              <Route path="/totalReport" element={<ConsolidatedReport />} />
              <Route path="/gstSplit" element={<GSTSplit />} />
              <Route path="/master" element={<MasterSeatEditor />} />
              <Route path="/fullReport" element={<FullReport />} />
              <Route path="/singleReport" element={<SingleReport />} />

              <Route path="/reportV2" element={<ReportsV2 />} />
              <Route path="/revenueReportsV2" element={<RevenueReportV2 />} />
              <Route path="/paymentSelectorV2" element={<PaymentOrReportSelectorV2 />} />
              <Route path="/totalReportV2" element={<ConsolidatedReportV2 />} />
              <Route path="/gstSplitV2" element={<GSTSplitV2 />} />
              <Route path="/fullReportV2" element={<FullReportV2 />} />
              <Route path="/singleReportV2" element={<SingleReportV2 />} />
              <Route path="/showPerformanceV2" element={<ShowPerformanceV2 />} />


              {/* <Route path="/redirectToTicket" element={<RedirectToTicket />} /> */}
              {/* <Route path="/redirectToTicket/:merchantTransactionId" element={<RedirectToTicket />} /> */}

              {/* // </Routes> */}

              {/* // </BookingProvider> */}

              {/* // </BookingContext.Provider> */}
            </>
          )}
        </Routes>
      </BookingProvider>

      {/* <Route
          path="/payment" // For creating a new package
          element={<UploadBankStatement />}
        />
      </Routes> */}
    </Suspense>
  );
}

export default AppRoutes;
